import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c62150b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }

import { onBeforeUnmount, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pPopup',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit;
const emitClose = () => emits('close');


const popupRef = ref<HTMLElement | null>(null);

const handleKey = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    emitClose();
  }
};

watch(() => props.visible, (newVal) => {
  document.body.style.overflow = newVal ? 'hidden' : 'initial';

  if (newVal) {
    document.addEventListener('keydown', handleKey);
  } else {
    document.removeEventListener('keydown', handleKey);
  }
});

onBeforeUnmount(() => {
  document.body.style.overflow = 'initial';
  document.removeEventListener('keydown', handleKey);
});


return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "popup__bg",
            onMousedown: emitClose
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "popup__body",
            tabindex: "0",
            ref_key: "popupRef",
            ref: popupRef
          }, [
            _createElementVNode("span", {
              class: "popup__close",
              onClick: emitClose
            }),
            _renderSlot(_ctx.$slots, "content")
          ], 512 /* NEED_PATCH */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})